export default "__VITE_ASSET__Qt3iH4FV__"